import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const InstitutionView = () => {
  const { id } = useParams();
  const [inst, setInst] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/institution/${id}`)
         .then(r => setInst(r.data))
         .catch(console.error);
  }, [id]);

  if (!inst) return <p className="text-center mt-5">Yükleniyor…</p>;

  const img = inst.cover
    ? (inst.cover.startsWith("http") ? inst.cover : `${process.env.REACT_APP_API_BASE_URL}${inst.cover}`)
    : "/images/placeholder.jpg";

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header fw-bold">{inst.title}</div>
        <div className="card-body">
          <div className="text-center mb-3">
            <img src={img} alt="cover" className="img-thumbnail" style={{ maxWidth: 250 }} />
          </div>

          <ul className="list-group list-group-flush mb-3">
            <li className="list-group-item"><strong>İl:</strong> {inst.city}</li>
            <li className="list-group-item"><strong>İlçe:</strong> {inst.district}</li>
            <li className="list-group-item">
            <strong>Slogan:</strong> {inst.slogan || "—"}
          </li>
                      <li className="list-group-item">
              <strong>Oluşturma:</strong>{" "}
              {new Date(inst.created_at).toLocaleString("tr-TR")}
            </li>
          </ul>

        </div>
      </div>
    </div>
  );
};

export default InstitutionView;
